import { STEP_IDENTIFIER_NAME } from '../constants';
import type { StepConfig } from '../types';

const { MEDIA } = STEP_IDENTIFIER_NAME;

export const media: StepConfig = {
	name: MEDIA,
	isAuthenticationRequired: false,
	isEnabled: () => true,
};
